import { Language } from "@/constants";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

export type TranslationResponse = {
  original_language: Language;
  target_language: Language;
  text: string;
  translated_text: string;
};

export const translate = (body: { text: string; target_language: Language }) =>
  fetcher_v2<TranslationResponse>(URLS.TRANSLATE, {
    method: "POST",
    body,
  });
